<template>
  <div class="info-section">
    <!-- <h2>STEM 교육 연구 정보</h2>
    <div class="info-cards">
      <div class="info-card">
        <h3>🔬 Science</h3>
        <p>과학적 탐구와 실험을 통한 학습</p>
      </div>
      <div class="info-card">
        <h3>💻 Technology</h3>
        <p>기술을 활용한 창의적 문제해결</p>
      </div>
      <div class="info-card">
        <h3>⚙️ Engineering</h3>
        <p>설계와 제작을 통한 공학적 사고</p>
      </div>
      <div class="info-card">
        <h3>📊 Mathematics</h3>
        <p>수학적 모델링과 논리적 사고</p>
      </div>
    </div> -->

    <!-- AI 테스트 도구 섹션 -->
    <div class="ai-tools-section">
      <h2>🤖 AI 테스트 도구</h2>
      <div class="tools-cards">
        <!-- <router-link to="/vlm-test" class="tool-card">
          <div class="tool-icon">🖼️</div>
          <h3>VLM 이미지 분석</h3>
          <p>Vision Language Model을 사용한 이미지 설명 생성</p>
          <div class="tool-features">
            <span class="feature-tag">이미지 분석</span>
            <span class="feature-tag">음성 출력</span>
            <span class="feature-tag">WebGPU</span>
          </div>
        </router-link> -->
        
        <router-link to="/whisper-test" class="tool-card">
          <div class="tool-icon">🎤</div>
          <h3>Whisper 음성 인식</h3>
          <p>OpenAI Whisper 모델을 사용한 실시간 음성 인식</p>
          <div class="tool-features">
            <span class="feature-tag">음성 인식</span>
            <span class="feature-tag">실시간</span>
            <span class="feature-tag">한국어</span>
          </div>
        </router-link>

        <!-- <router-link to="/webcam-test" class="tool-card">
          <div class="tool-icon">📷</div>
          <h3>Webcam 손가락 트래킹</h3>
          <p>실시간 웹캠 피드를 사용한 손 추적</p>
          <div class="tool-features">
            <span class="feature-tag">손 추적</span>
            <span class="feature-tag">실시간</span>
            <span class="feature-tag">웹캠</span>
          </div>
        </router-link> -->

        <router-link to="/Aruco" class="tool-card">
          <div class="tool-icon">📷</div>
          <h3>FingerTip + ROI 테스트</h3>
          <p>웹캠을 사용한 ArUco 마커와 손가락 위치 인식</p>
          <div class="tool-features">
            <span class="feature-tag">마커 인식</span>
            <span class="feature-tag">실시간</span>
            <span class="feature-tag">웹캠</span>
          </div>
        </router-link>

        <router-link to="/Excel-test" class="tool-card">
          <div class="tool-icon">📊</div>
          <h3>Excel 테스트</h3>
          <p>Excel 파일을 사용한 테스트</p>
          <div class="tool-features">
            <span class="feature-tag">Excel</span>
            <span class="feature-tag">CSV</span>
            <span class="feature-tag">Tabular</span>
          </div>
        </router-link>

        <!-- <router-link to="/QA-test" class="tool-card">
          <div class="tool-icon">🎤</div>
          <h3>검색 엔진 활용 데이터 탐색</h3>
          <p>궁금한 정보를 검색하여 텍스트를 차트 촉각 그래픽으로 변환</p>
          <div class="tool-features">
            <span class="feature-tag">RAG</span>
            <span class="feature-tag">검색엔진</span>
            <span class="feature-tag">텍스트 변환</span>
          </div>
        </router-link> -->

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoSection'
}
</script>

<style scoped>
.info-section {
  background: white;
  border-radius: 15px;
  padding: 2rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
}

.info-section h2 {
  text-align: center;
  margin-bottom: 2rem;
  color: #2c3e50;
}

.info-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 3rem;
}

.info-card {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: white;
  padding: 1.5rem;
  border-radius: 10px;
  text-align: center;
  transition: transform 0.3s ease;
}

.info-card:hover {
  transform: translateY(-5px);
}

.info-card h3 {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}

.info-card p {
  font-size: 0.9rem;
  opacity: 0.9;
}

/* AI 도구 섹션 스타일 */
.ai-tools-section {
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 2px solid #f0f0f0;
}

.tools-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.tool-card {
  display: block;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 2rem;
  border-radius: 15px;
  text-decoration: none;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.tool-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  color: white;
  text-decoration: none;
}

.tool-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  transition: left 0.5s;
}

.tool-card:hover::before {
  left: 100%;
}

.tool-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
  text-align: center;
}

.tool-card h3 {
  font-size: 1.4rem;
  margin-bottom: 1rem;
  text-align: center;
  color: white;
}

.tool-card p {
  font-size: 1rem;
  opacity: 0.9;
  text-align: center;
  margin-bottom: 1.5rem;
  line-height: 1.5;
}

.tool-features {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: center;
}

.feature-tag {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  padding: 0.3rem 0.8rem;
  border-radius: 15px;
  font-size: 0.8rem;
  font-weight: 500;
  backdrop-filter: blur(10px);
}

@media (max-width: 768px) {
  .info-cards, .tools-cards {
    grid-template-columns: 1fr;
  }
  
  .info-section {
    padding: 1.5rem;
  }
  
  .tool-card {
    padding: 1.5rem;
  }
  
  .tool-icon {
    font-size: 2.5rem;
  }
  
  .tool-card h3 {
    font-size: 1.2rem;
  }
}
</style>
